import { render, staticRenderFns } from "./DepartmentSummaryChat.vue?vue&type=template&id=74573862&scoped=true"
import script from "./DepartmentSummaryChat.vue?vue&type=script&lang=js"
export * from "./DepartmentSummaryChat.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSummaryChat.vue?vue&type=style&index=0&id=74573862&prod&lang=scss"
import style1 from "./DepartmentSummaryChat.vue?vue&type=style&index=1&id=74573862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74573862",
  null
  
)

export default component.exports